module.exports = __webpack_public_path__ + "img/antfu-qrcode.0b954be6.png";